var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"warning-feedback"},[_c('i',{staticClass:"icon icon-warning-01"}),_c('ul',{staticClass:"warning-feedback__items"},_vm._l((_vm.warningMessages),function(message){return _c('li',{key:message,staticClass:"warning-feedback__item"},[_vm._v(" "+_vm._s(message)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }